import React, { useContext, useRef, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { UncertainContext } from '../../contexts/uncertainContext';
import { timeFromDob, UNCERTAIN_KEYS_LIST } from '../utilsUncertain';
import { Background } from '../UiKit/Background';
import { Icon } from '../UiKit/Icon';
import { Preview } from '../UiKit/Preview';
import { Full } from './Full';

export { UncertainSourceSelect } from './UncertainSourceSelect';

const UncertainThumb = ({
  designKey,
  design,
  dob,
  active,
  onEnter,
  onLeave,
  selected,
  onSelect,
}) => {
  const context = useContext(LangContext);
  const $type = context.$type;
  const $profile = context.$profile;
  const parentContainer = useRef(null);
  const profileId = design?.profile?.[0] && design?.profile?.[1]
    ? `${design.profile[0]}${design.profile[1]}`
    : '';

  return (
    <div className={`x_edu_ava1 x_uncertain_thumb ${active || selected ? 'active' : ''}`}>
      <div className="x_uncertain_thumb_time">{timeFromDob(dob)}</div>
      <div className="x_edu_ava1_body">
        <div
          className={`x_click x_click--penta mobile_vh_no ${active || selected ? 'active' : ''}`}
          style={{ zIndex: 4 }}
          onClick={onSelect}
          onMouseEnter={onEnter}
          onMouseOut={onLeave}
        />
        <div
          className={`x_click x_click--penta mobile_vh_yes ${active || selected ? 'active' : ''}`}
          style={{ zIndex: 4 }}
          onClick={onSelect}
        />
        <div className="x_edu_ava1_bodygraph" ref={parentContainer}>
          {design && (
            <Preview
              key={design.id}
              parentContainer={parentContainer}
              design={design}
              aura={false}
            />
          )}
        </div>
        {design && <Background design={design} />}
      </div>
      <div className="x_penta_typeprofile">
        {design?.type && (
          <>
            {$type(design.type, 'title_compact')} {profileId && $profile(profileId, 'profile')}
            {profileId && (
              <>
                <br />
                "{$profile(profileId, 'title')}"
              </>
            )}
          </>
        )}
      </div>
      <button
        type="button"
        className={`x_uncertain_thumb_pick ${selected ? 'active' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          onSelect();
        }}
        aria-pressed={selected}
      >
        <Icon>{selected ? 'check_circle' : 'radio_button_unchecked'}</Icon>
      </button>
    </div>
  );
};

export const Uncertain = React.memo((props) => {
  const uncertain = useContext(UncertainContext);
  const [preview, setPreview] = useState('common');

  const currentDesign = preview === 'common'
    ? (uncertain.common || props.avatar?.design)
    : (uncertain.designs?.[preview] || props.avatar?.design);

  const currentAvatar = {
    ...props.avatar,
    design: currentDesign || props.avatar?.design,
  };

  const handleSelect = (key) => {
    uncertain.setMain(uncertain.main === key ? 'uncertain' : key);
  };

  return (
    <>
      <Full
        {...props}
        avatar={currentAvatar}
        advanced={false}
        underlayDesign={preview === 'common' ? uncertain.potential : null}
        omitUnderlayGates={preview === 'common' ? uncertain.commonGates : null}
        omitUnderlayCenters={preview === 'common' ? uncertain.commonCenters : null}
        questionPlanets={preview === 'common' ? uncertain.changingPlanets : null}
      />

      {uncertain.designs && (
        <div className="x_uncertain_thumbs">
          <div className="x_uncertain_thumbs_row">
            {UNCERTAIN_KEYS_LIST.map((key) => (
              <UncertainThumb
                key={key}
                designKey={key}
                design={uncertain.designs?.[key]}
                dob={uncertain.dobs?.[key]}
                active={preview === key}
                onEnter={() => setPreview(key)}
                onLeave={() => setPreview('common')}
                selected={uncertain.main === key}
                onSelect={() => handleSelect(key)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
});
